'use strict'

export default class BackToTopButton {
  wire () {
    // Get the button
    const backToTopButton = $('#back-to-top')
    const pixelThreshold = 500

    // When the user scrolls down 20px from the top of the document, show the button
    window.onscroll = function () {
      scrollSpy()
    }

    function scrollSpy () {
      if (
        document.body.scrollTop > pixelThreshold ||
        document.documentElement.scrollTop > pixelThreshold
      ) {
        backToTopButton.addClass('active')
      } else {
        backToTopButton.removeClass('active')
      }
    }

    // When the user clicks on the button, scroll to the top of the document
    backToTopButton.on('click', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    })
  }
}
